export const GET_USER = 'GET_USER'
export const GET_USER_PENDING = 'GET_USER_PENDING'
export const GET_USER_FULFILLED = 'GET_USER_FULFILLED'
export const GET_USER_REJECTED = 'GET_USER_REJECTED'